import { Link } from 'react-router-dom'
import { ENTRY_PLANS, priceOf } from '@/lib/marketing/pricing'
import styles from './HomePricingTeaser.module.css'

// A compact 3-up of the ENTRY ladder (Trial → Coach → Club) — the three steps a
// visitor can actually start on. It used to slice the club plans and land on
// "Trial · Club · National Center", whose third card prices eight courts: the
// ceiling, not anyone's next step. The arrangement now lives in pricing.ts beside
// the ladder it arranges, so this teaser and /pricing cannot disagree about it.

/** § Pricing teaser (T3 §1.2). A compact 3-up + the openness angle + one link to
 *  the full pricing page. Does not rebuild the full table. */
export function HomePricingTeaser() {
  return (
    <section className={styles.teaser} aria-labelledby="home-pricing-title" data-track-section>
      <div className={styles.head} data-enter="left">
        <h2 id="home-pricing-title" className={styles.title}>
          Simple pricing, published openly
        </h2>
        {/* Scoped to the COURT ladder — the three cards below and the two rungs
            above them. The blanket "every feature on every plan" was false for
            Organizer (competitions only), and "priced by court count" is false
            for it too: Organizer sits off the court axis entirely. Both are
            ladder claims, so say so. */}
        <p className={styles.body}>
          Every plan on this ladder includes it all, starting with a free month. You pay only as you
          grow — priced by court count, with no hidden quotes.
        </p>
      </div>

      <div className={styles.grid} data-enter="rise">
        {ENTRY_PLANS.map((tier) => (
          <div key={tier.name} className={styles.card} data-track-light>
            <span className={styles.tierName}>{tier.name}</span>
            <span className={styles.tierPrice}>
              {tier.price}
              {tier.cadence ? <span className={styles.cadence}>{tier.cadence}</span> : null}
            </span>
            <span className={styles.tierCourts}>{tier.courts}</span>
          </div>
        ))}
      </div>

      {/* What the 3-up leaves out: the competitions-only plan beside the ladder,
          and the two rungs above it. The price is read, never typed. */}
      <p className={styles.advanced} data-enter="left" data-enter-late>
        Running competitions only? Organizer is {priceOf('Organizer')}/mo · National and Federation
        Center cover the largest clubs
      </p>

      <Link className={styles.link} to="/pricing" data-enter="left" data-enter-late>
        See full pricing <span aria-hidden="true">→</span>
      </Link>
    </section>
  )
}
